import { render, staticRenderFns } from "./IP_ByCoder.vue?vue&type=template&id=7d439730&scoped=true&"
import script from "./IP_ByCoder.vue?vue&type=script&lang=js&"
export * from "./IP_ByCoder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d439730",
  null
  
)

export default component.exports